import React from 'react';

const SettingsContentSection = props => {

    const { containerStyle, headerStyle, spaceBetween } = styles;
    let updatedContainerStyle = {}

    if (props.masterBilling) {
        updatedContainerStyle.marginLeft = 0;
        updatedContainerStyle.marginTop = 15;
    } else if (props.halfWidth) {
        updatedContainerStyle.width = 'calc(45% - 15px)';
    }

    return (
        <div style={{ ...containerStyle, ...updatedContainerStyle }}>
            <div>
                <div style={headerStyle}>
                    {props.headingIcon}
                    <span style={spaceBetween}>{props.headingText}</span>
                </div>
            </div>
            {props.children}
        </div>
    );
}

export default SettingsContentSection;

let styles = {
    containerStyle: {
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: '10px 0px 10px 15px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingRight: 15
    },
    headerStyle: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4,
        marginTop: -3
    }
}


// WEBPACK FOOTER //
// ./src/components/common/SettingsContentSection.js